import { Pipe, PipeTransform } from '@angular/core';
import { hrTextOn } from '@app/shared/_models/hr';

// Noir ou blanc sur un fond CHOISI PAR L'UTILISATEUR — les couleurs des personnes et des services
// se règlent à la main (fiche salarié, service), on ne peut donc pas figer la couleur du texte :
// un jaune vif et un bleu marine ne portent pas la même.
//
// Un PIPE plutôt qu'une méthode : trois composants (planning, fiche salarié, organisation)
// portaient chacun la même enveloppe d'une ligne autour de `hrTextOn`, uniquement parce qu'un
// template Angular ne sait pas appeler une fonction de module. Le pipe le sait, et il est pur —
// Angular ne le rappelle que si la couleur change.
@Pipe({ name: 'hrTextOn', standalone: true })
export class HrTextOnPipe implements PipeTransform {
	transform(bg: string | null | undefined): string {
		return hrTextOn(bg ?? '');
	}
}
